import React, { useEffect, useState } from 'react';
import { Button, Modal } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../DialogBox/DialogBox.module.scss';
import { useTranslation } from 'react-i18next';

interface ConfirmDialogProps {
  dropDownList?: (
    setSelection: React.Dispatch<React.SetStateAction<string | undefined>>,
    shouldValidate: boolean,
  ) => JSX.Element;
  confirmTranslationKey: string;
  confirmAction: (selection?: string) => void;
}

interface AlertDialogProps {
  okTranslationKey?: string | undefined;
}

function DialogBox(props: {
  title: string;
  message: string;
  confirmOptions?: ConfirmDialogProps | undefined;
  alertOptions?: AlertDialogProps | undefined;
  cancelTranslationKey?: string | undefined;
  showModalState: boolean;
  closeAction: () => void;
}) {
  const { t } = useTranslation();
  const [selection, setSelection] = useState<string | undefined>(undefined);
  const [shouldValidate, setShouldValidate] = useState<boolean>(false);

  useEffect(() => {
    setShouldValidate(!props.showModalState);
    setSelection(props.showModalState ? undefined : selection);
  }, [props.showModalState]);

  return (
    <Modal
      open={props.showModalState}
      onClose={() => props.closeAction()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className={styles['dialog-box']}>
        <div className={styles['dialog-title']}>
          <h2>{t(props.title)}</h2>
          <div className={styles['exit-dialog']}>
            <FontAwesomeIcon
              icon="xmark"
              onClick={() => {
                props.closeAction();
              }}
            />
          </div>
        </div>
        <div className={styles['dialog-message']}>
          <p>{t(props.message)}</p>
          <span>
            {props.confirmOptions?.dropDownList &&
              props.confirmOptions?.dropDownList(setSelection, shouldValidate)}
          </span>
        </div>
        <div className={styles['dialog-buttons']}>
          {props.confirmOptions ? (
            <>
              <Button
                onClick={() => {
                  setShouldValidate(true);
                  if (props.confirmOptions?.dropDownList && selection) {
                    props.confirmOptions?.confirmAction(selection);
                    setShouldValidate(false);
                    props.closeAction();
                  } else if (!props.confirmOptions?.dropDownList) {
                    props.confirmOptions?.confirmAction();
                    props.closeAction();
                  }
                }}
              >
                {t(props.confirmOptions?.confirmTranslationKey)}
              </Button>
              <Button
                onClick={() => {
                  props.closeAction();
                }}
              >
                {t(props.cancelTranslationKey || 'Cancel')}
              </Button>
            </>
          ) : (
            <Button
              onClick={() => {
                props.closeAction();
              }}
            >
              {t(props.alertOptions?.okTranslationKey || 'OK')}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default DialogBox;
